import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAllEntities, 
} from '../store/entitiesSlice';
//import { addOrder, updateOrder, setOrders, selectBuyOrders } from '../store/ordersSlice';
import { addMarketMakerOrder, selectAllMarketMakerOrders, updateMarketMakerOrder } from '../store/marketMakerOrdersSlice';
import OrderForm from './OrderForm';
import OrderHistory from './OrderHistory';
//import MarketMakerOrdersList from './components/MarketMakerOrdersList';
import { selectAllOrders } from '../store/ordersSlice';
import UserPositions from './components/UserPositions';
import AccountBalance from './components/AccountBalance';
import UpdateAccountBalance from './components/UpdateAccountBalance';
import TransactionHistory from './components/TransactionHistory';
//import useFetchEntities from './hooks/useFetchEntities';
//import AddNewEntity from './components/AddNewEntity';
//import ManagedEntities from './components/ManagedEntities';
import { matchUserOrderWithMarketMakers } from './clearingService';
import { createOffsettingOrder, fulfillUserOrder } from './marketMakerService';
import AuthDisplay from '../AuthDisplay';
import UserMarginHolds from './components/UserMarginHolds';
import { 
  fetchOrdersForUser,
  saveOrder, 
  updateOrderStatusToAPI,
  fetchPositionsForUser,
  fetchTransactionsForUser,
  getAccountBalance,
  // fetchEntities,
  fetchMarginHoldsForUser,
  fetchActiveCommodities
} from './api';
// import { selectCommodities } from '../store/commoditiesSlice';
import PriceSetterNotification from './PriceSetterNotification';
import CommoditiesList from './components/CommoditiesList';
import { selectUser } from '../store/userSlice';
import CommodityForm from './components/CommodityForm';

const PriceSetter = ({ 
}) => {
  const dispatch = useDispatch();
  const entities = useSelector(selectAllEntities);
  const marketMakerOrders = useSelector(selectAllMarketMakerOrders);
  const userOrders = useSelector(selectAllOrders);
  const user = useSelector(selectUser);
  
    const getCommodities = async (dispatch) => {
        // await getAccountBalance(user.uid, dispatch);
        // await fetchMarginHoldsForUser(user.uid, dispatch);
        await fetchActiveCommodities(dispatch);
        // await fetchOrdersForUser(user.uid, dispatch);
        // await fetchPositionsForUser(user.uid, dispatch);
        // await fetchTransactionsForUser(user.uid, dispatch);
        // await fetchEntities(dispatch);
    };

  useEffect(() => {
    getCommodities(dispatch);
  }, [dispatch]);


  // useFetchEntities();
    const getData = async (user, dispatch) => {
      if (user && user.uid) {
        await getAccountBalance(user.uid, dispatch);
        await fetchMarginHoldsForUser(user.uid, dispatch);
        // await fetchActiveCommodities(dispatch);
        await fetchOrdersForUser(user.uid, dispatch);
        await fetchPositionsForUser(user.uid, dispatch);
        await fetchTransactionsForUser(user.uid, dispatch);
        // await fetchEntities(dispatch);
      }
    };

  // get past orders for the user.
  useEffect(() => {
    getData(user, dispatch);
  }, [user, dispatch]);
  
  async function handleOrderSubmit(order) {
    // Save order to backend database
    if (user && user?.uid) {
      await saveOrder(order, user.uid);
      getData(user, dispatch);
    }
  }

  // function currently not used, processing handled on the server.
  const handleMultiMatchOrder = async (userOrder) => {
    const createOppositeOrder = (order) => {
      // For now, just return the order object
      return { ...order, status: 'open' };
    };

    const matches = matchUserOrderWithMarketMakers(userOrder, marketMakerOrders, createOppositeOrder);
    const newMarketMakerOrders = [];
    
    // Fulfill the user order by closing relevant market maker orders and creating new market maker orders
    matches.forEach(match => {
      if (match.isNew) {
        // Create new market maker order
        dispatch(addMarketMakerOrder(match));
        newMarketMakerOrders.push(match);
      }
    });

    // loop through matches and update market maker orders as fulfilled
    matches.forEach(match => {
      dispatch(updateMarketMakerOrder({ id: match.id, updates: { status: 'fulfilled' } }));
    })

    updateOrderStatusToAPI(userOrder.id, 'fulfilled')
    .then((data) => {
      // Check if offset is needed
      const entity = entities.find(e => e.id === userOrder.entityId);
      const offsetOrder = createOffsettingOrder([...marketMakerOrders, ...newMarketMakerOrders], entity);
      if (offsetOrder) {
        dispatch(addMarketMakerOrder(offsetOrder));
      }

      // add user positions since order is fulfilled, add transaction and update account balance.
      // this should be done on the server.
      fulfillUserOrder(userOrder, dispatch);
      
    });

  };

  // State for selecting a user order for multi-match
  const [selectedUserOrderId, setSelectedUserOrderId] = useState('');

  const handleQuasiMatchOrder = async (userOrder) => {
    // const createOppositeOrder = (order) => {}
  }

  return (
    <div style={{
      maxWidth: 1400,
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif'
    }}>

    <AuthDisplay />

      <AccountBalance />
      <UserMarginHolds />
      {user && user.uid && (
        <>
          <UpdateAccountBalance />
        </>
      )}
      <h2 style={{ textAlign: 'center', margin: '0 0 24px 0', color: '#333' }}>
        Trading Dashboard
      </h2>

      <CommoditiesList />

      {user && user.uid && (
        <>
          <OrderForm 
            onOrderSubmit={handleOrderSubmit}
            minQuantity={1}
            maxQuantity={10000}
          />
        </>
      )}


      {/* Manual Match Orders Button */}
      <div style={{ textAlign: 'center', marginBottom: 20, display: 'flex', gap: 16, justifyContent: 'center' }}>

        {/* Multi-Match User Order Button and Dropdown */}
        {/* <select
          value={selectedUserOrderId}
          onChange={e => setSelectedUserOrderId(e.target.value)}
          style={{
            padding: '8px 12px',
            borderRadius: 6,
            border: '1px solid #ccc',
            fontSize: 16
          }}
        >
          <option value="">Select User Order</option>
          {userOrders.filter(order => order.status !== 'fulfilled' && order.status !== 'cancelled').map(order => (
            <option key={order.id} value={order.id}>
              {order.type.toUpperCase()} {order.quantity} {order.entityName} @ ${order.price}
            </option>
          ))}
        </select>
        <button
          onClick={() => {
            const selectedOrder = userOrders.find(o => o.id === selectedUserOrderId);
            if (selectedOrder) handleMultiMatchOrder(selectedOrder);
          }}
          disabled={!selectedUserOrderId}
          style={{
            background: '#8e44ad',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '10px 28px',
            fontWeight: 'bold',
            fontSize: 16,
            cursor: selectedUserOrderId ? 'pointer' : 'not-allowed',
            boxShadow: '0 2px 6px rgba(142,68,173,0.08)'
          }}
        >
          Multi-Match Order
        </button>
        <button
          onClick={() => {
            const selectedOrder = userOrders.find(o => o.id === selectedUserOrderId);
            if (selectedOrder) handleQuasiMatchOrder(selectedOrder);
          }}
          disabled={!selectedUserOrderId}
          style={{
            background: '#27ae60',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '10px 28px',
            fontWeight: 'bold',
            fontSize: 16,
            cursor: selectedUserOrderId ? 'pointer' : 'not-allowed',
            boxShadow: '0 2px 6px rgba(39,174,96,0.08)'
          }}
        >
          Quasi-Match Order
        </button> */}
      </div>

      {user && user.uid === 'yubsHdIO3mNoXlQaSBvdotKPk2z1' && (
          <CommodityForm/>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginBottom: 24 }}>
        {/* Left Column - Entity Management */}
        {/* <div style={{
          border: '1px solid #ddd',
          borderRadius: 8,
          padding: 20,
          background: '#fafcff'
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#333' }}>
            Entity Price Manager (Redux)
          </h3>

          <AddNewEntity/>

        </div> */}

        {/* Right Column - Order Form */}
        <div>
          {/* <OrderForm 
            onOrderSubmit={handleOrderSubmit}
            minQuantity={1}
            maxQuantity={10000}
          /> */}
        </div>
        {/* <div>
          <ManagedEntities />  
        </div> */}

      </div>

      {/* User Positions Section */}
      <UserPositions refreshData={getData} />

      {/* Market Maker Orders Section */}
      {/* <div style={{ marginTop: 24 }}>
        <h3 style={{ marginBottom: 16, color: '#333', borderBottom: '1px solid #eee', paddingBottom: 8 }}>
          Market Maker Orders
        </h3>
        <MarketMakerOrdersList />
      </div> */}

      {/* Order History Section */}
      <div style={{ marginTop: 24 }}>
        <OrderHistory />
      </div>

      {/* Transaction History Section */}
      <TransactionHistory />

      <PriceSetterNotification />
    </div>
  );
};

export default PriceSetter;